module.exports = __webpack_public_path__ + "images/fa-bf-bg-billing-mobile.webp";